export default "/MIM3CRV.efc2ec69ad327f27102ef10101c08014.png";